import inspections from './inspections'

export default { inspections }
